module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-600.5a71131c.woff";